const deleteVehicleMaintenanceUseCase = (repository) => async (id) => {
    return await repository(id);
}

export default deleteVehicleMaintenanceUseCase;